import slugify from "slugify";

export function slugifier(
  value: string,
  options?: {
    replacement?: string;
    remove?: RegExp;
    lower?: boolean;
    strict?: boolean;
    locale?: string;
    trim?: boolean;
  },
): string {
  return slugify(value, {
    replacement: options?.replacement || "-",
    remove: options?.remove,
    lower: options?.lower || true,
    strict: options?.strict || false,
    locale: options?.locale || "en",
    trim: options?.trim || true,
  });
}

export function slugifierForCatalog(
  value: string,
  options?: {
    replacement?: string;
    lower?: boolean;
    strict?: boolean;
    locale?: string;
    trim?: boolean;
  },
): string {
  value = value.replaceAll("&", " "); // Replace ampersands with spaces
  value = value.replaceAll("'", " "); // Replace apostrophes with spaces

  return slugifier(value, {
    ...options,
    remove: /[*+~.,;:!?()"@/#]/g,
  });
}
